import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '../src/assets/scss/layout.scss'
import { BootstrapVue } from 'bootstrap-vue'
import axios from "@/plugin/axios.js";
import VueAxios from 'vue-axios';
import logout from '@/mixin/logout.js';

Vue.use(VueAxios, axios);

Vue.mixin(logout);
Vue.use(BootstrapVue)
Vue.component('v-select', vSelect)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')